import { render, staticRenderFns } from "./UserAdminList.vue?vue&type=template&id=4ffc7bc0&scoped=true&"
import script from "./UserAdminList.vue?vue&type=script&lang=js&"
export * from "./UserAdminList.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminList.vue?vue&type=style&index=0&id=4ffc7bc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffc7bc0",
  null
  
)

export default component.exports